import { Action } from '@ngrx/store';
import { PayloadAction } from '@ipreo/muni-shared';

const SET_DEAL_DATE = '[marketDrawer] Set Deal Date';
const OPEN_DRAWER = '[marketDrawer] Open Drawer';
const CLOSE_DRAWER = '[marketDrawer] Close Drawer';
const TOGGLE_DRAWER = '[marketDrawer] Toggle Drawer';
const RESET_DATA = '[marketDrawer] Reset Data';

/* tslint:disable:max-classes-per-file */
/* tslint:disable:no-null-keyword */
class SetDealDateAction implements PayloadAction<Date> {
    public readonly type = SET_DEAL_DATE;

    constructor(public payload: Date) {}
}

class OpenDrawerAction implements Action {
    public readonly type = OPEN_DRAWER;
}

class CloseDrawerAction implements Action {
    public readonly type = CLOSE_DRAWER;
}

class ToggleDrawerAction implements Action {
    public readonly type = TOGGLE_DRAWER;
}

class ResetDataAction implements Action {
    public readonly type = RESET_DATA;
}

type Actions =
    | SetDealDateAction
    | OpenDrawerAction
    | CloseDrawerAction
    | ToggleDrawerAction
    | ResetDataAction;

export {
    SET_DEAL_DATE,
    OPEN_DRAWER,
    CLOSE_DRAWER,
    TOGGLE_DRAWER,
    RESET_DATA,
    SetDealDateAction,
    OpenDrawerAction,
    CloseDrawerAction,
    ToggleDrawerAction,
    ResetDataAction,
    Actions
};
